import { keyframes } from '@emotion/react';

// Timing configuration
export const TIMING = {
  autoRotateInterval: 6000, // 6s per feature - enough for AI chat to complete
  transitionDuration: 300, // fade between features
  typewriterCharDelay: 30, // ms per character
  typewriterJitter: 20, // random 0-20ms added
  typewriterLineDelay: 200, // pause between lines
  swipeThreshold: 50, // px to register swipe
  progressUpdateInterval: 50, // update progress bar every 50ms
};

// Feature definitions
export const FEATURES = [
  {
    id: 'ai-chat',
    title: 'Unlimited AI Research',
    description: 'Unlimited chat messages — no daily limits',
    icon: 'Chat',
    tab: 'AI Chat',
  },
  {
    id: 'daily-picks',
    title: 'AI-Curated Stock Picks',
    description: 'Copy trade our AI portfolio managers',
    icon: 'Research',
    tab: 'Picks',
  },
  {
    id: 'news-charts',
    title: 'News on Every Chart',
    description: 'See what moved every stock on every chart',
    icon: 'News',
    tab: 'News',
  },
  {
    id: 'smart-alerts',
    title: 'Smart Alerts',
    description: 'Never miss a trade with actionable alerts',
    icon: 'Alerts',
    tab: 'Alerts',
  },
  {
    id: 'portfolio',
    title: 'Portfolio Monitoring',
    description: 'Connect your brokerage for 24/7 portfolio monitoring',
    icon: 'Portfolio',
    tab: 'Portfolio',
  },
  {
    id: 'market-updates',
    title: 'Daily Market Updates',
    description: 'Personalized market insights delivered daily',
    icon: 'Updates',
    tab: 'Updates',
  },
] as const;

export type FeatureId = (typeof FEATURES)[number]['id'];

// Shared animation keyframes
export const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.95);
  }
`;

export const slideInFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const scaleIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const blink = keyframes`
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0;
  }
`;

export const drawLine = keyframes`
  from {
    stroke-dashoffset: 200;
  }
  to {
    stroke-dashoffset: 0;
  }
`;

export const typingDots = keyframes`
  0%, 20% {
    opacity: 0.3;
  }
  40% {
    opacity: 1;
  }
  60%, 100% {
    opacity: 0.3;
  }
`;
